import Style from '../../style'
import {END} from 'shared/constant/lookup/eventState'

const BadgeSection = ({event_state, can_eliminate, user_can_join}) => {
	return (
		<Style.BadgesContainer>
			{event_state !== END && user_can_join && (
				<Style.StatusBadge statusColor='inProgress'>
					<Style.StatusText statusColor='inProgress'>진행 중</Style.StatusText>
				</Style.StatusBadge>
			)}

			{can_eliminate && (
				<Style.StatusBadge statusColor='participating'>
					<Style.StatusText statusColor='participating'>
						참여 중
					</Style.StatusText>
				</Style.StatusBadge>
			)}
		</Style.BadgesContainer>
	)
}

export default BadgeSection
